import React, { useEffect, useState } from 'react'
import { MainContext, useContext } from '../Main/MainContext'
import Layout from '../Components/Layout'
import { useTranslation } from 'react-i18next'
import { api, server, prefix, endpoints } from './../Main/Api';

import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend
} from "chart.js";
import SeansGrafik from '../Components/SeansGrafik';
import { Link } from 'react-router-dom';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend
);

export default function Dashboard() {

  const { user, token } = useContext(MainContext)
  const { t } = useTranslation()

  const [loading, setLoading] = useState(false)
  const [data, setData] = useState(null)

  const getDashboard = () => {
    if (loading) return;
    setLoading(true);

    const url = server + prefix + endpoints.dashboard;
    api.request(url, "GET", {}, {
      "Authorization": "Bearer " + token
    }).then((response) => {
      const { hata, data } = response.data;
      setData(data)
      setLoading(false);
    });
  }
  useEffect(() => {
    getDashboard()
  }, [])


  const GunlukSeansGrafigi = ({ data }) => {
    const labels = data.map(item => item.gun);
    const values = data.map(item => item.adet);

    return (
      <div style={{ width: "100%", height: "350px" }}>
        <Line
          data={{
            labels,
            datasets: [
              {
                label: "Günlük Uygulanan Tedavi Sayısı",
                data: values,
                borderWidth: 2,
                tension: 0.3,
              }
            ]
          }}
          options={{
            responsive: true,
            maintainAspectRatio: false
          }}
        />
      </div>
    );
  }

  return (
    <Layout baslik={t('Dashboard')}>
      {
        loading ?
          <>
            <div className="text-center mt-5">
              <i className="fas fa-spinner fa-spin fa-2x mb-2"></i>
              <p>{t("yukleniyor...")}</p>
            </div>
          </>
          :
          <>

            {
              (!loading && data != null) && (
                <div className="row mb-3">

                  <div className="col-md-4">
                    <div className="card">
                      <div className="card-body">
                        <h1>{data.hastaSayisi}</h1>
                        <h5>Toplam Hastanız</h5>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="card">
                      <div className="card-body">
                        <h1>{data.favoriHastaSayisi}</h1>
                        <h5>Favori Hastalar</h5>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="card">
                      <div className="card-body">
                        <h1>{data.aktifTedaviSayisi}</h1>
                        <h5>Aktif Tedavi Sayısı</h5>
                      </div>
                    </div>
                  </div>

                </div>
              )
            }

            {
              (!loading && data?.seansData) ? (
                <SeansGrafik baslik={"Son 15 Gün Seans Grafiği"} seansData={data.seansData} />
              ) : null
            }

            {
              (!loading && data?.bugunkuHastalar) &&
              <>
                <div className="row">
                  <div className="col-md-12">
                    <div className="card shadow">
                      <div className="card-header">
                        <h5 className="card-title mb-0">Bugün Tedavisi Bulunan Hastalar</h5>
                      </div>
                      <div className="card-body">
                        {
                          data.bugunkuHastalar.length > 0 ?
                            <>
                              <div className="table-responsive">
                                <table className="table table-striped table-sm">
                                  <thead>
                                    <tr>
                                      <th>#</th>
                                      <th>Ad Soyad</th>
                                      <th>Telefon</th>
                                      <th className='text-center'>Tedavi Durumu</th>
                                      <th></th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {
                                      data.bugunkuHastalar.map((item, index) => (
                                        <tr>
                                          <td>{index + 1}</td>
                                          <td>
                                            <Link to={"/hasta/goruntule/" + item.hasta.kullanici_kodu}>
                                              {item.hasta.ad + " " + item.hasta.soyad}
                                            </Link>
                                          </td>
                                          <td>{item.hasta.telefon}</td>
                                          <td className='text-center'>
                                            {
                                              item.uygulanan_tedavi_id > 0 ?
                                                <>
                                                  <span className="badge badge-success">
                                                    <i className="fas fa-check"></i> Tamamlandı
                                                  </span>
                                                </>
                                                :
                                                <>
                                                  <span className="badge badge-danger">
                                                    <i className="fas fa-times"></i> Tamamlanmadı
                                                  </span>
                                                </>
                                            }
                                          </td>
                                          <td>
                                            <Link to={`/tedavi/goruntule/${item.tedavi_id}`} className='btn btn-dark btn-sm'>
                                              <i className="fas fa-link"></i> Tedavi Bilgileri
                                            </Link>
                                          </td>
                                        </tr>
                                      ))
                                    }
                                  </tbody>
                                </table>
                              </div>
                            </>
                            :
                            <>
                              <p className='mb-0'>Bugün tedavisi bulunan hastanız yok.</p>
                            </>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </>
            }
          </>
      }
    </Layout>
  )
}
